(function () {
  function initCarousel(root) {
    if (root.dataset.ypaInitialized === 'true') return;
    root.dataset.ypaInitialized = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ypa-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ypa-dot]'));
    var previous = root.querySelector('[data-ypa-prev]');
    var next = root.querySelector('[data-ypa-next]');
    if (slides.length !== 2 || dots.length !== 2) return;

    var active = 0;
    var timer;
    var paused = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var selected = i === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var selected = i === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-current', selected ? 'true' : 'false');
      });
    }

    function stop() {
      window.clearInterval(timer);
      timer = undefined;
    }

    function start() {
      stop();
      if (paused || reduceMotion.matches || document.hidden || (window.Shopify && window.Shopify.designMode)) return;
      timer = window.setInterval(function () { show(active + 1); }, 5000);
    }

    previous.addEventListener('click', function () { show(active - 1); start(); });
    next.addEventListener('click', function () { show(active + 1); start(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); start(); });
    });
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) { paused = false; start(); }
    });
    document.addEventListener('visibilitychange', start);
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', start);
    show(0);
    start();
  }

  function initJourneySlider(root) {
    if (root.dataset.ypaJourneyInitialized === 'true') return;
    root.dataset.ypaJourneyInitialized = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ypa-journey-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ypa-journey-dot]'));
    if (slides.length < 2) return;

    var active = 0;
    var timer;
    var paused = false;
    var clearPrevious;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function show(index) {
      var previous = active;
      active = (index + slides.length) % slides.length;
      if (active === previous) return;

      slides.forEach(function (slide) { slide.classList.remove('is-prev'); });
      slides[previous].classList.remove('is-on');
      slides[previous].classList.add('is-prev');
      slides[previous].setAttribute('aria-hidden', 'true');
      slides[active].classList.add('is-on');
      slides[active].setAttribute('aria-hidden', 'false');

      dots.forEach(function (dot, i) {
        var selected = i === active;
        dot.classList.toggle('is-on', selected);
        dot.setAttribute('aria-selected', selected ? 'true' : 'false');
      });

      window.clearTimeout(clearPrevious);
      clearPrevious = window.setTimeout(function () {
        slides[previous].classList.remove('is-prev');
      }, 600);
    }

    function stop() {
      window.clearInterval(timer);
      timer = undefined;
    }

    function start() {
      stop();
      if (paused || reduceMotion.matches || document.hidden || (window.Shopify && window.Shopify.designMode)) return;
      timer = window.setInterval(function () { show(active + 1); }, 5000);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); start(); });
    });
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) { paused = false; start(); }
    });
    document.addEventListener('visibilitychange', start);
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', start);
    start();
  }

  function initAll(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-ypa-carousel]'), initCarousel);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-ypa-journey-slider]'), initJourneySlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
